import LayoutAdmin from "../components/layouts/LayoutAdmin";
import LayoutInicio from "../components/layouts/LayoutInicio";
import LayoutParticipante from "../components/layouts/LayoutParticipante";

import Users from "../pages/Users";
import BDParticipante from "../pages/BDParticipante";
import Reportes from "../pages/Reportes";
import Login from "../pages/Login";
import Error404 from "../pages/404";

import ParticipanteEstadoInscripcion from "../pages/Participante/PEstadoInscripcion";
import ParticipanteSolicitarContrasenia from "../pages/Participante/PContraseniaSolicitar";
import ParticipanteReenviarContrasenia from "../pages/Participante/PContraseniaReenviar";

import Sorteo from "../pages/Sorteo";
import Sortear from "../pages/Sorteo/Sortear";
import SorteoGanador from "../pages/Sorteo/SorteoGanador";

import ParticipanteLogin from "../pages/Participante/PLogin";
import ParticipanteFormularioRegistro from "../pages/Participante/PFormulario";

import Transferencia from "../pages/Transferencia";
import Participante from "../pages/Participante";
import ParticipanteRevision from "../pages/Participante/Revision";

import ParticipanteInscribirse from "../pages/Participante/PInscribirse";

import SorteoPublic from "../pages/SorteoPublic";
import SorteoPublicGanadores from "../pages/SorteoPublic/SorteoPublicGanadores";
import Home from "../pages/Home";

import Credenciales from "../pages/Credenciales";
import Configuracion from "../pages/Configuracion";

const routes = [
  {
    path: "/app",
    component: LayoutAdmin,
    exact: false,
    routes: [
      {
        path: "/app",
        component: Home,
        exact: true
      },
      {
        path: "/app/usuarios",
        component: Users,
        exact: true
      },
      {
        path: "/app/transferencia",
        component: Transferencia,
        exact: true
      },
      {
        path: "/app/bdparticipante",
        component: BDParticipante,
        exact: true
      },
      {
        path: "/app/participantes/:name",
        component: Participante,
        exact: true
      },
      {
        path: "/app/participante/:nrodocumento",
        component: ParticipanteRevision,
        exact: true
      },
      {
        path: "/app/sorteo",
        component: Sorteo,
        exact: true
      },
      {
        path: "/app/sortear",
        component: Sortear,
        exact: true
      },
      {
        path: "/app/sorteo/:codigo",
        component: SorteoGanador,
        exact: true
      },
      {
        path: "/app/reportes",
        component: Reportes,
        exact: true
      },
      {
        path: "/app/credenciales",
        component: Credenciales,
        exact: true
      },
      {
        path: "/app/configuracion",
        component: Configuracion,
        exact: true
      },
      {
        component: Error404
      }
    ]
  },

  {
    path: "/inscripcion",
    component: LayoutParticipante,
    exact: false,
    routes: [
      {
        path: "/inscripcion",
        component: ParticipanteEstadoInscripcion,
        exact: true
      },
      {
        path: "/inscripcion/formulario",
        component: ParticipanteFormularioRegistro,
        exact: true
      },
      {
        component: Error404
      }
    ]
  },

  {
    path: "/",
    component: LayoutInicio,
    exact: false,
    routes: [
      {
        path: "/",
        component: ParticipanteLogin,
        exact: true
      },
      {
        path: "/reenviar-contrasenia",
        component: ParticipanteReenviarContrasenia,
        exact: true
      },
      {
        path: "/solicitar-contrasenia",
        component: ParticipanteSolicitarContrasenia,
        exact: true
      },
      {
        path: "/inscribirse",
        component: ParticipanteInscribirse,
        exact: true
      },
      {
        path: "/sorteo",
        component: SorteoPublic,
        exact: true
      },
      {
        path: "/sorteo/:codigo",
        component: SorteoPublicGanadores,
        exact: true
      },
      {
        path: "/auth/login",
        component: Login,
        exact: true
      },
      {
        component: Error404
      }
    ]
  }
];

export default routes;
